/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
import { mergeMap } from './mergeMap';
import { identity } from '../util/identity';
export function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap(identity, concurrent);
}
//# sourceMappingURL=mergeAll.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/mergeAll.js
// module id = 341
// module chunks = 2